import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IScoring = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="21"
            viewBox="0 0 23 21"
            fill="none"
          >
            <path
              d="M11.3443 15.9912L16.9508 19L16.1721 12.9823L21 8.31858L14.459 7.71681L11.3443 2L8.54098 7.86726L2 8.31858L6.67213 12.9823L5.58197 19L11.3443 15.9912Z"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IScoring;
